import script from "./info.vue?vue&type=script&setup=true&lang=js"
export * from "./info.vue?vue&type=script&setup=true&lang=js"

import "./info.vue?vue&type=style&index=0&id=60a4e5a4&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60a4e5a4"]])

export default __exports__